import { Box, Table } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { AppPagination } from "../../../../components/AppPagination/AppPagination";
import { TableNoResults } from "../../../../components/TableNoResults/TableNoResults";
import classes from "./flagsDetailsAdvancedSearch.module.scss";

const DEFAULT_TAKE = 20;

const FlaggedDataTable = ({ columns, rows }) => {
  const [page, setPage] = useState(0);
  const [take, setTake] = useState(DEFAULT_TAKE);

  const normalizedColumns = columns.map((column) =>
    typeof column === "string" ? { key: column, label: column } : column,
  );

  const paginatedRows = useMemo(() => {
    const start = page * take;
    return rows.slice(start, start + take);
  }, [page, rows, take]);

  useEffect(() => {
    const lastPage = Math.max(0, Math.ceil(rows.length / take) - 1);

    if (page > lastPage) {
      setPage(lastPage);
    }
  }, [page, rows.length, take]);

  const handlePageChange = (newPage) => {
    setPage(newPage - 1);
  };

  const handleTakeChange = (newTake) => {
    setTake(newTake);
  };

  const tableRows = paginatedRows.map((row, index) => (
    <Table.Tr key={`${page}-${index}`}>
      {normalizedColumns.map((column) => (
        <Table.Td key={column.key}>
          {column.render
            ? column.render(row)
            : (row.data?.[column.key] ?? row[column.key])}
        </Table.Td>
      ))}
    </Table.Tr>
  ));

  return (
    <>
      <Box className="table-panel">
        <Table
          horizontalSpacing="md"
          highlightOnHover
          stickyHeader
          className={classes["flagged-data-table"]}
        >
          <Table.Thead>
            <Table.Tr>
              {normalizedColumns.map((column) => (
                <Table.Th key={column.key}>{column.label}</Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>

          {rows.length === 0 ? (
            <Table.Tbody>
              <TableNoResults colSpan={normalizedColumns.length || 1} />
            </Table.Tbody>
          ) : (
            <Table.Tbody>{tableRows}</Table.Tbody>
          )}
        </Table>
      </Box>
      {rows.length > 0 && (
        <AppPagination
          page={page}
          take={take}
          total={rows.length}
          onPageChange={handlePageChange}
          onTakeChange={handleTakeChange}
        />
      )}
    </>
  );
};

export default FlaggedDataTable;
